module.exports = __webpack_public_path__ + "static/Medium-ed8a9cd50fd172d028f33a62e09a4693.png";